import { Link, LinkProps } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export const JobDetailsLink: React.FC<{
  jobId: string;
  children?: React.ReactNode;
  color?: LinkProps['color'];
  variant?: LinkProps['variant'];
  title?: string;
  ariaLabel?: string;
  sx?: LinkProps['sx'];
}> = ({ jobId, children, color = 'inherit', variant, title, ariaLabel, sx }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  searchParams.set('jobDrawerOpen', '1');
  searchParams.set('currentJobId', jobId);

  return (
    <Link
      component={RouterLink}
      to={{ pathname: location.pathname, search: searchParams.toString() }}
      color={color}
      variant={variant}
      title={title}
      aria-label={ariaLabel}
      sx={sx}
      underline="hover"
    >
      {children || jobId}
    </Link>
  );
};
